<template>
	<div class="bg-[#F5F9FA] h-screen pt-[43px] box-border">
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[40px] flex items-center">
			<img @click="backIndex()" src="@/static/image/icon12.png" class="cursor-pointer w-[24px] h-[24px]" alt="" />
			<label @click="backIndex()"
				class="cursor-pointer text-[18px] text-[#000000]">{{langInfo.login_home}}</label>
		</div>
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto bg-white rounded-[10px] flex ">
			<div
				class="w-[450px] h-[700px]  rounded-[10px] leftContent text-white flex  flex-col items-center pt-[6%] pl-[40px] pr-[40px] box-border">
				<img src="@/static/image/logo.png" class="w-[140px] h-[140px] mb-[80px]" alt="" srcset="" />
				<div class="text-[36px]   font-bold mb-[20px]">
					{{langInfo.login_hello}}，
					{{langInfo.login_welcome}}
				</div>
				<!-- 注册页面 -->
				<div @click="goLogin()"
					class="w-[240px] py-[14px] px-[8px] cursor-pointer  rounded-[50px] border border-solid border-white text-[18px] font-semibold  text-center">
					{{langInfo.reg_login}}
				</div>
			</div>
			<!-- 注册页面 -->
			<div class="min-h-[700px] pb-[20px] box-border flex  flex-col items-center pt-[6%] box-border"
				style="width: calc(100% - 450px);">
				<div class="text-[42px] text-[#000000] font-bold mb-[20px]">
					{{langInfo.reg_title}}
				</div>
				<div class="w-[520px] mx-auto ">
					<div class="pr-[40px]">
						<div class="mb-[30px] flex  text-[16px] text-[#101010]">
							<div @click="selectLoginMethod(1)" :class="loginMethod==1?'active':''"
								class="loginTitle  cursor-pointer relative mr-[60px]">
								{{langInfo.login_email}}
							</div>
							<div @click="selectLoginMethod(2)" :class="loginMethod==2?'active':''"
								class="loginTitle cursor-pointer relative mr-[60px]">
								{{langInfo.login_tel}}
							</div>
							<div @click="selectLoginMethod(3)" :class="loginMethod==3?'active':''"
								class="loginTitle cursor-pointer relative">
								{{langInfo.reg_wx}}
							</div>
						</div>
						<div v-if="loginMethod==1"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon80.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
							<input v-model="email" :placeholder="langInfo.login_email_tip" class="text-[16px] flex-1" />
						</div>
						<div v-else-if="loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon13.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
							<input v-model="phone" :placeholder="langInfo.login_tel_tip" class="text-[16px] flex-1" />
						</div>
						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon14.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
							<input v-model="password" type="password" :placeholder="langInfo.login_password_tip"
								class="text-[16px] flex-1" />
						</div>
						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon14.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
							<input v-model="nextPassword" type="password" :placeholder="langInfo.reg_password_tip"
								class="text-[16px] flex-1" />
						</div>

						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px]  bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon15.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
							<input v-model="code" :placeholder="langInfo.reg_code_tip" class="text-[16px] flex-1" />
							<div @click="getCodeClick()"
								class="min-w-[126px] px-[10px] box-border whitespace-no-wrap cursor-pointer text-[18px] text-[#3894FF] font-semibold text-right"
								style="">
								{{getCodeText}}
							</div>
						</div>
					</div>
					<div v-if="loginMethod==1" class=" mb-[24px] text-[#B8B8B8]">
						<label class="text-[#FF0000]">{{langInfo.reg_tip}}：</label>{{langInfo.reg_tip_content}}
					</div>
					<div v-else-if="loginMethod==2" class=" mb-[24px] text-[#B8B8B8]">
						<label class="text-[#FF0000]">{{langInfo.login_tip}}：</label>{{langInfo.login_tip_content}}
					</div>
					<div @click="registerBtn()" v-if="loginMethod!=3"
						class="w-[248px] h-[64px] cursor-pointer mb-[30px] mx-auto leading-[64px] rounded-[50px] bg-[#3894FF] text-center text-white text-[18px] font-bold">
						{{langInfo.reg_submit}}
					</div>
					<div class="flex items-center flex-wrap" v-if="loginMethod!=3">
						<img :src="isCheck?checkActive:check" @click="isCheck=!isCheck"
							class="w-[16px] h-[16px] mr-[6px] cursor-pointer" alt="" srcset="" />
						{{langInfo.reg_read}} <router-link :to="{path:'/agreement',query: { mark: 'UserAgreement' }}"
							class="text-[#3894FF] no-underline"
							target="_blank">《{{langInfo.reg_agree}}》</router-link>{{langInfo.reg_and}}<router-link
							:to="{path:'/agreement',query: { mark: 'PrivacyAgreement' }}"
							class="text-[#3894FF] no-underline" target="_blank">《{{langInfo.reg_hide}}》</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
				
				loginMethod: 1, //1邮箱 2手机号 3微信
				email: '',
				phone: '',
				password: "",
				nextPassword: '',
				code: '', //验证码
				langInfo: '',

				getCodeText: '',
				getCodeisWaiting: false,

				isCheck: false,
				checkActive: require('../../static/image/icon17.png'),
				check: require('../../static/image/icon16.png'),
			}
		},
		mounted() {
			localStorage.removeItem('userInfo')
			localStorage.removeItem('token')
			this.langInfo = this.$store.getters['lang/getLangList']
			console.log("langInfo===");
			console.log(this.langInfo);
			this.getCodeText = this.langInfo.reg_get_code
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.getCodeText = this.langInfo.reg_get_code
					console.log(this.langInfo);
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			// 选择登录方式
			selectLoginMethod(method) {
				this.loginMethod = method;
				this.email = "";
				this.phone = "";
				this.password = "";
				this.nextPassword = "";
				this.code = "";


				this.getCodeisWaiting = false;
				this.getCodeText = this.langInfo.reg_get_code
				clearInterval(this.Timer)
				this.Timer = null
			},
			backIndex() {
				this.$router.replace({ path: '/' })
			},
			// 去登录
			goLogin() {
				this.$router.push({ path: '/login' })
			},
			// 获取验证码
			getCodeClick() {

				if (this.loginMethod == 1) {
					if (!this.email) {
						this.$message({
							message: this.langInfo.login_email_tip,
							type: 'warning'
						});
						return
					}
				} else if (this.loginMethod == 2) {
					if (!this.phone) {
						this.$message({
							message: this.langInfo.login_tel_tip,
							type: 'warning'
						});
						return
					}
				}

				if (this.getCodeisWaiting) {
					return
				}
				this.getCodeText = this.langInfo.sending //发送验证码
				this.getCodeisWaiting = true;

				this.getCode()
			},
			getCodeTimer() {
				let holdTime = 60; //定义变量并赋值
				// this.getCodeText = "重新获取60s"
				this.Timer = setInterval(() => {
					if (holdTime <= 0) {
						this.getCodeisWaiting = false;
						this.getCodeText = this.langInfo.reg_get_code
						clearInterval(this.Timer); //清除该函数
						return; //返回前面
					}
					this.getCodeText = this.langInfo.re_obtain + holdTime + "s"
					holdTime--;
				}, 1000)
			},

			getCode() {

				if (this.loginMethod == 1) {
					this.$api.sendResetPasswordCode({
						email: this.email,
						type: 'register'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				} else if (this.loginMethod == 2) {
					this.$api.send({
						phone: this.phone,
						user_register: 'user_register'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}


			},

			// 立即注册
			registerBtn() {
				if (!this.isCheck) {
					this.$message({
						message: this.langInfo.login_agree_tip,
						type: 'warning'
					});
					return
				}
				if (this.loginMethod == 1) {
					this.emailRegister() //邮箱注册
				} else if (this.loginMethod == 2) {
					this.phoneRegister() //手机号注册
				}
			},
			phoneRegister() {
				if (!this.phone) {
					this.$message({
						message: this.langInfo.login_tel_tip,
						type: 'warning'
					});
					return
				}
				const reg = /^1[3456789]\d{9}$/;
				if (!reg.test(this.phone)) {
					this.$message({
						message: this.langInfo.wrong_phone_number,
						type: 'warning'
					});
					return
				}

				if (!this.password) {
					this.$message({
						message: this.langInfo.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langInfo.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langInfo.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langInfo.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.register({
					mobile: this.phone,
					password: this.password,
					type: 2,
					code: this.code
				}).then((res) => {

					this.$message({
						message: this.langInfo.registered_successfully,
						type: 'success'
					});

					this.$api.login({
						mobile: this.phone,
						password: this.password,
						type: 2,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {

								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径

								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			emailRegister() {
				if (!this.email) {
					this.$message({
						message: this.langInfo.login_email_tip,
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: this.langInfo.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langInfo.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langInfo.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langInfo.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.register({
					email: this.email,
					type: 1,
					password: this.password,
					code: this.code
				}).then((res) => {
					console.log(res);
					this.$message({
						message: this.langInfo.registered_successfully,
						type: 'success'
					});

					this.$api.login({
						email: this.email,
						password: this.password,
						type: 1,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {
								this.$router.push('/studyCenter/study/videosCourse?type=0'); // 使用完整路径
								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}
		}
	}
</script>

<style scoped>
	.leftContent {
		background: linear-gradient(137.58deg, rgba(56, 148, 255, 1) -0.52%, rgba(56, 148, 255, 0.6) 112.81%);
	}

	.loginTitle.active::after {
		content: "";
		position: absolute;
		width: 42px;
		height: 8px;
		background-color: rgba(41, 121, 255, 1);
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	input {
		border: none;
		background-color: transparent;
	}

	input:focus {
		outline: none;
	}

	input::placeholder {
		color: #CCCCCC;
		/* 例如，设置为灰色 */
	}
</style>